export default __webpack_public_path__ + "static/groupbanner-cf3e0d8c3d8c19ebc49efba84c3faf9e.svg";